import React from 'react';
import { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DropdownFilter from '../../Components/Common/DropdownFilter';

function AvailableCertifications(){
    const [readMore, setReadMore] = useState(false);
    const extraContent =
        <div>
            <div className="expand-table certificate_table table-responsive">
                <tbody className="table">
                    <tr>
                        <td>Lorem Ipsum is simply dummy text of the printing and...</td>
                        <td>NISM Certificate</td>
                        <td>24</td>
                        <td>Intermediate</td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>Lorem Ipsum is simply</td>
                        <td>NSC Academy</td>
                        <td>24</td>
                        <td>Basic</td>
                        <td>-</td>
                    </tr>
                </tbody>
            </div>
        </div>

    
    return(

        <div className="card-box">
        <div className="card-title">
            <h2>Available Certifications</h2>
            <div className="card-right">
                <div className="dropdown-filter">
                    <DropdownFilter/>
                </div>
                <div className="filter-tabs">
                    <ul className=" nav nav-tabs" id="pills-tab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="pills-stocks-tab" data-toggle="pill"
                                data-target="#pills-stocks" type="button" role="tab"
                                aria-controls="pills-stocks" aria-selected="true">Stocks</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-mutualfunds-tab" data-toggle="pill"
                                data-target="#pills-mutualfunds" type="button" role="tab"
                                aria-controls="pills-mutualfunds" aria-selected="false">Mutual
                                Funds</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-insurance-tab" data-toggle="pill"
                                data-target="#pills-insurance" type="button" role="tab"
                                aria-controls="pills-insurance" aria-selected="false">Insurance</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div className="tab-content" id="pills-tabContent">
            <div className="tab-pane fade show active" id="pills-stocks" role="tabpanel"
                aria-labelledby="pills-stocks-tab">
                {/* <!-- stocks --> */}
                <div className="expand-table scroll-table certificate_table">
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">Certificate Name</th>
                                <th scope="col">Issuer</th>
                                <th scope="col">No. of Modules</th>
                                <th scope="col">Level</th>
                                <th scope="col">Fee</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Lorem Ipsum is simply dummy text of the printing and...</td>
                                <td>NSC Academy</td>
                                <td>20</td>
                                <td>@Basic</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>Lorem Ipsum is simply dummy</td>
                                <td>NSC Academy</td>
                                <td>22</td>
                                <td>Intermediate</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>Lorem Ipsum is simply dummy text of the printing and...</td>
                                <td>NSC Academy</td>
                                <td>24</td>
                                <td>Intermediate</td>
                                <td>-</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <div className="more-btn" onClick={() => { setReadMore(!readMore) }}>
                    {readMore && extraContent}
                    {readMore ? 'view Less' : 'view more'}

                </div>
                {/* <!-- <a href="/" className="more-btn d-block">View more</a> --> */}
            </div>
            <div className="tab-pane fade" id="pills-mutualfunds" role="tabpanel"
                aria-labelledby="pills-mutualfunds-tab">
                {/* <!-- mutualfunds --> */}
                <div className="expand-table certificate_table table-responsive">
                    <table className="table table-fit">
                        <thead>
                            <tr>
                                <th scope="col">Certificate Name</th>
                                <th scope="col">Issuer</th>
                                <th scope="col">No. of Modules</th>
                                <th scope="col">Level</th>
                                <th scope="col">Fee</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Lorem Ipsum is simply dummy text of the printing and...</td>
                                <td>NSC Academy</td>
                                <td>20</td>
                                <td>@Basic</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>Lorem Ipsum is simply dummy</td>
                                <td>NSC Academy</td>
                                <td>22</td>
                                <td>Intermediate</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>Lorem Ipsum is simply dummy text of the printing and...</td>
                                <td>NSC Academy</td>
                                <td>24</td>
                                <td>Intermediate</td>
                                <td>-</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <div className="more-btn" onClick={() => { setReadMore(!readMore) }}>
                    {readMore && extraContent}
                    {readMore ? 'view Less' : 'view more'}

                </div>
            </div>
            <div className="tab-pane fade" id="pills-insurance" role="tabpanel"
                aria-labelledby="pills-insurance-tab">
                {/* <!-- insurance --> */}
                <div className="expand-table certificate_table table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">Certificate Name</th>
                                <th scope="col">Issuer</th>
                                <th scope="col">No. of Modules</th>
                                <th scope="col">Level</th>
                                <th scope="col">Fee</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Lorem Ipsum is simply dummy text of the printing and...</td>
                                <td>NSC Academy</td>
                                <td>20</td>
                                <td>@Basic</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>Lorem Ipsum is simply dummy</td>
                                <td>NSC Academy</td>
                                <td>22</td>
                                <td>Intermediate</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>Lorem Ipsum is simply dummy text of the printing and...</td>
                                <td>NSC Academy</td>
                                <td>24</td>
                                <td>Intermediate</td>
                                <td>-</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <div className="more-btn" onClick={() => { setReadMore(!readMore) }}>
                    {readMore && extraContent}
                    {readMore ? 'view Less' : 'view more'}

                </div>
            </div>
        </div>
    </div>
    )
}
export default AvailableCertifications;